import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Box } from '@mui/material';
import AlertMessage from 'src/components/Alert/Alert';
import AlertSeverity from 'src/components/Alert/AlertEnums';
import Toolbar from './Toolbar';
import AccountingBalanceTabs from './AccountingBalanceTabs';

const AccountingBalanceView = ({ contract }) => {
  const [tabIndex, setTabIndex] = useState(0);

  return (
    <Box mt={3} display="flex" flexDirection="column">
      <AlertMessage
        title="COMMON.INTERNAL_BALANCE_WARNING"
        severity={AlertSeverity.WARNING}
        open
        hideCloseIcon
      />
      <AccountingBalanceTabs
        contract={contract}
        tabIndex={tabIndex}
        setTabIndex={setTabIndex}
        actions={<Toolbar tabIndex={tabIndex} />}
      />
    </Box>
  );
};

AccountingBalanceView.propTypes = {
  contract: PropTypes.object.isRequired
};

export default AccountingBalanceView;
